import { useMutation } from '@tanstack/react-query';

import AppointmentsRepository from '@/repositories/members/AppointmentsRepository';
import { LeaveVideoAppointmentParams } from '@/types/videoSessions';

export const useLeaveVideoAppointment = () => {
  const repository = AppointmentsRepository();

  return useMutation({
    mutationFn: (data: LeaveVideoAppointmentParams) => repository.leaveVideoAppointment(data)
  });
};
